import * as React from "react";
import Talks from "./talks";
import { talksData } from "../data";
import { useLang } from "../lang";

const TalksSection: React.FC = () => {
  const { langEn } = useLang();

  return (
    <div id="talks" className="container justify-content-center">
      <p className="title mb-2">{langEn ? "Invited Talks and Seminars" : "招待講演・セミナー"}</p>

      <div className="row">
        <Talks items={talksData} />
      </div>
    </div>
  );
};

export default TalksSection;
